/* StageLine Gear — minimal theme JS */
document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle (placeholder — will be expanded as needed)
  var mobileBtn = document.querySelector('[data-mobile-nav-toggle]');
  var nav = document.querySelector('nav.primary');
  if (mobileBtn && nav) {
    mobileBtn.addEventListener('click', function () {
      nav.classList.toggle('open');
    });
  }

  // Cart count live update via Shopify cart API
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.querySelector('.cart-count');
        if (el) el.textContent = cart.item_count;
      })
      .catch(function () { /* silent */ });
  }
  refreshCartCount();

  // Form newsletter — let Shopify handle the submit; just smooth UX
  var newsForm = document.querySelector('.news-form');
  if (newsForm) {
    newsForm.addEventListener('submit', function () {
      var btn = newsForm.querySelector('button');
      if (btn) btn.textContent = 'Signing up...';
    });
  }
});
